import React, { Component } from 'react';
import { Image } from 'react-bootstrap';
import './KaomojiMixer.css';

class KaomojiMixer extends Component {
    render() {
        return (
            <div className="project-page">
                <h3 className="project-date">May 2017</h3>
                <h1 className="project-title">Kaomoji Mixer</h1>
                <p className="project-description">Kaomoji Mixer is an android app created using Android Studio and Java that makes Japanese emoticons called Kaomoji.</p>
                <p></p>
                <p className="bold">How to Use:</p>
                <p className="project-description">
                    <ol>
                        <li>Create the kaomoji you want by giving it face, eyes, mouth, and misc component as separated by
                        columns from left to right</li>
                        <li>You can edit your kaomoji by hitting the delete (DEL) or clear (C) button</li>
                        <li>Hit MAKE will all finalize the kaomoji in the bigger view box and then allow you to COPY the
                        kaomoji onto your clipboard for use in conversation and chat</li>
                        <li>Bonus feature: Hitting the ADD button will display an image of a crying face whenever TT is used
                        in the kaomoji.</li>
                    </ol>
                </p>
                <a className="project-url" src="https://github.com/joy8zhang/KaomojiMixer">Github</a>
                <div className="project-image-container">
                    <Image src={require('./img/project/kaomoji/kaomoji1.png')} className="project-image"/>
                    <Image src={require('./img/project/kaomoji/kaomoji2.png')} className="project-image"/>
                    <Image src={require('./img/project/kaomoji/kaomoji3.png')} className="project-image"/>
                </div>
            </div>
        );
    }
}

export default KaomojiMixer;



// WEBPACK FOOTER //
// ./src/projects/KaomojiMixer.js